export default {
  title: 'Плюсы путешествий с Трипстером',
  theses: {
    refund: {
      title: 'Гарантия возврата и удобная отмена',
      subtitle: 'Планы изменились? Бесплатная отмена за 48 часов. Если экскурсия не состоялась — вернём деньги',
    },
    support: {
      title: 'Заботливая поддержка на каждом этапе',
      subtitle: 'Поможем с выбором, ответим на любые вопросы — до, во время и после экскурсии',
    },
    askGuide: {
      title: 'Можно задать вопросы гиду заранее',
      subtitle: 'Связь с гидом до экскурсии и предоплаты для уверенности и комфорта',
    },
  },
} as const;
